import { useMutation, useQuery } from "react-query";
import { getRequest } from "../../../services/api";
import { ErrorHandling } from "../../ErrorHandling";
import { alert, alertLoading } from "../../../@core/components/alert";
import { useAuth } from "../useAuth";
import { useEffect } from "react";
import { getFrontParam } from "../../Utils";

export const QUERY_KEY_RESEND_MAIL_VERIFY = "QUERY_KEY_RESEND_MAIL_VERIFY";
export const QUERY_KEY_ME = "QUERY_KEY_ME";
export function useGetResendMailVerify() {
  const { mutate, isLoading } = useMutation({
    mutationFn: (id: any) => {
      return getResendMailVerify(id);
    },
    onError: (error: any, variables, context) => {
      ErrorHandling(error);
      console.log(error);
    },
    onSuccess: (data, variables, context) => {
      alert("Email enviado com Sucesso", "success");
    },
  });
  if (isLoading) {
    alertLoading("Enviando email...", "info");
  }
  return {
    isLoading,
    mutate,
  };
}

export async function getResendMailVerify(id) {
  try {
    const frontParam = getFrontParam();
    const url = frontParam
      ? `mail/resend/${id}?front=${frontParam}`
      : `mail/resend/${id}`;
    const data = await getRequest(url);
    return data;
  } catch (error: any) {
    throw error;
  }
}

export async function getMe() {
  try {
    const data = await getRequest(`me`);
    return data;
  } catch (error: any) {
    throw error;
  }
}

export function useGetMe() {
  const { setUser } = useAuth();
  const { data, isError, isLoading, error, isFetching } = useQuery(
    [QUERY_KEY_ME],
    () => getMe(),
    {
      staleTime: 1000 * 60 * 60 * 3, // 3 horas
      cacheTime: 1000 * 60 * 60 * 3, // 3 horas
      refetchInterval: 1000 * 60 * 60 * 3, // 3 horas
      refetchIntervalInBackground: true,
      suspense: false,
    }
  );
  useEffect(() => {
    if (data) {
      localStorage.setItem("@revalida.user", JSON.stringify(data));
    }
  }, [data, isFetching]);

  return {
    data,
    isError,
    isLoading,
    error,
  };
}
